import React from 'react';

import cn from 'classnames';

import { THEME } from '@constants/base';

import styles from './index.module.less';

interface ModalTitleProps {
  title: string;
  subTitle: string;
  className?: string;
  theme?: Theme;
}

export const ModalTitle: React.FC<ModalTitleProps> = ({ title, subTitle, className, theme }) => {
  return (
    <div className={cn(styles.title, className, {
      [styles.darkTitle]: theme === THEME.DARK
    })}>
      <p className={styles.title}>{title}</p>
      <p className={styles.subTitle}>{subTitle}</p>
    </div>
  )
}
